'use client'

import dynamic from 'next/dynamic'

const DistinctiveFactorsChartBubbles = dynamic(() => import('./DistinctiveFactorsChartBubbles'), { ssr: false })

export default DistinctiveFactorsChartBubbles
